import React, { useState, useEffect, useCallback } from "react";
import { HeaderAcc } from "../../Components";
import { Toast } from "../../Components";
import PricingMain from "./PricingMain";
import { accountService, billingService, planService } from "../../Services";
import ModalPricingPlatformCreate from "./ModalPricingPlatformCreate";
import ModalAccActivation from "../Account/Activation/ModalActivation";
import ModalPricingformCreate from "./ModalPricingformCreate";
import ModalPricingSignIn from "./ModalPricingSignIn";
import { useSearchParams } from "react-router-dom";
import ModalConfirmSubscriptionAction from "./ModalConfirmSubscriptionAction";
import ModalSubscribe from "../../Components/Base/Common/Modal/ModalSubscribe";
import { storageHandler } from "../../Helpers/storage";

export default function Pricing({
  user,
  referPageUrl,
  cartItem,
  closeCartPanel,
  setAuth,
  NotifModul,
  account,
  profiles,
  setModalNotification,
}) {
  const [tab] = useState("main"); // Removed setTab since it's unused
  const [planType, setPlanType] = useState("monthly");
  const [planTypeShow, setPlanTypeShow] = useState("Month");
  const [toastList, setToastList] = useState([]);
  const [roleId, setRoleId] = useState(null);
  const [modal, setModal] = useState(null);
  const [planMonthly, setPlanMonthly] = useState([]);
  const [planYearly, setPlanYearly] = useState([]);
  const [planToShow, setPlanToShow] = useState([]);
  const [subModal, setSubModal] = useState(null);
  const [referId, setReferId] = useState(null);
  const [subsProductId, setSubsProductId] = useState(null);
  const [searchParams] = useSearchParams(); // Removed setSearchParams since it's unused
  const [isdowngradeProcessed, setIsdowngradeProcessed] = useState(false);
  const [updateAction, setUpdateAction] = useState("");
  const [actionProduct, setActionProduct] = useState(null);
  const [planWithFeaturesDetails, setPlanWithFeaturesDetails] = useState([]);
  const [isSubscriptionLoading, setIsSubscriptionLoading] = useState(false);
  const [isSubscribe, setIsSubscribe] = useState(false);
  const [loadingPlanId, setLoadingPlanId] = useState(null);
  const userToken = storageHandler.getToken();

  // Memoized addToast function to fix useEffect dependency issues
  const addToast = useCallback((data) => {
    setToastList((prevToastList) => {
      const newToastList = [...prevToastList];
      newToastList.push({
        ...data,
        id: `${Date.now()}-${prevToastList.length}`,
      });
      return newToastList;
    });
  }, []);

  useEffect(() => {
    if (isSubscribe) {
      setModal("subscribeNow");
    }
  }, [isSubscribe]);

  const setUserInfo = () => {
    if (userToken) {
      accountService.loginViaToken(userToken).then((res) => {
        // console.log("🚀 ~ cancelsub ~ res:", res);
      });
    }
  };

  // Utility function to safely handle API calls
  const safeApiCall = async (apiFunction, timeoutMs = 30000) => {
    const timeoutPromise = new Promise((_, reject) =>
      setTimeout(
        () => reject(new Error("Request timeout. Please try again.")),
        timeoutMs
      )
    );

    try {
      return await Promise.race([apiFunction(), timeoutPromise]);
    } catch (error) {
      console.error("API call error:", error);
      throw error;
    }
  };

  useEffect(() => {
    let paypalError =
      searchParams.get("error") !== null
        ? searchParams.get("error") === 1
          ? "We're having trouble connecting to your payment account. Please try again."
          : ""
        : "";
    let successMessage =
      searchParams.get("success") !== null
        ? searchParams.get("success") === 1
          ? "Processed Request."
          : ""
        : "";

    let allReadyError =
      searchParams.get("error") !== null
        ? searchParams.get("error") === 2
          ? "This email address is already registered."
          : ""
        : "";
    let subscriptionError =
      searchParams.get("error") !== null
        ? searchParams.get("error") === 3
          ? "Subscription already present for this user"
          : ""
        : "";
    let signInError =
      searchParams.get("error") !== null
        ? searchParams.get("error") === 4
          ? "Please SignUp "
          : ""
        : "";
    let ErrorForFail =
      searchParams.get("error") !== null
        ? searchParams.get("error") === 5
          ? "Something went wrong. Please try again later. "
          : ""
        : "";

    if (successMessage !== "") {
      addToast({
        error: false,
        msg: successMessage,
      });
    }
    if (ErrorForFail !== "") {
      addToast({
        error: true,
        msg: ErrorForFail,
      });
    }
    if (paypalError !== "") {
      addToast({
        error: true,
        msg: paypalError,
      });
    }
    if (signInError !== "") {
      addToast({
        error: true,
        msg: signInError,
      });
    }
    if (allReadyError !== "") {
      addToast({
        error: true,
        msg: allReadyError,
      });
    }
    if (subscriptionError !== "") {
      addToast({
        error: true,
        msg: subscriptionError,
      });
    }
  }, [searchParams, addToast]); // Added dependencies

  useEffect(() => {
    async function fetchPlanWithFeatures() {
      try {
        const res = await planService.getPlanWithFeatures();
        // console.log("🚀 ~ fetchPlanWithFeatures ~ res:", res);
        setPlanWithFeaturesDetails(res.data ? res.data : []);

        if (res.data && res.success) {
          const resSubscription =
            await planService.getAllForActiveSubscriptionData();
          console.log(
            "🚀 ~ fetchPlanWithFeatures ~ resSubscription:",
            resSubscription
          );

          const { monthlyPlans, yearlyPlans } = res.data?.reduce(
            (acc, plan) => {
              console.log("🚀 ~ fetchPlanWithFeatures ~ plan:", plan);
              plan.billing_options.forEach((option) => {
                const subscriptionData = resSubscription.data.find(
                  (item) =>
                    item.product_name === plan.name &&
                    item.product_id === option.id
                  // item.product_name === plan.name &&
                  // item.billing_cycle === option.billing_cycle &&
                  // parseFloat(item.price) === option.price
                );

                const enhancedPlan = {
                  ...plan,
                  ...option,
                  ...(subscriptionData && {
                    planaction: subscriptionData.planaction,
                    user_flag: subscriptionData.user_flag,
                    startdate: subscriptionData.startdate,
                    user_trial: subscriptionData.user_trial,
                    trial_days_left: subscriptionData.trial_days_left,
                    user_had_trial: subscriptionData.user_had_trial,
                    // is_trial: subscriptionData.is_trial,
                    isSubscribed: true,
                    // trial_days: subscriptionData.trial_days,
                  }),
                };

                if (option.billing_cycle === "monthly") {
                  acc.monthlyPlans.push(enhancedPlan);
                } else {
                  acc.yearlyPlans.push(enhancedPlan);
                }
              });
              return acc;
            },
            { monthlyPlans: [], yearlyPlans: [] }
          );

          const sortedPlans = (plans) => {
            return plans.sort((a, b) => {
              if (a?.display_order === 0) return -1;
              if (b?.display_order === 0) return 1;
              if (a?.display_order === 3) return 1;
              if (b?.display_order === 3) return -1;
              return a?.display_order - b?.display_order;
            });
          };

          const enhancedMonthlyPlans = sortedPlans(monthlyPlans);
          const enhancedYearlyPlans = sortedPlans(yearlyPlans);

          setPlanMonthly(enhancedMonthlyPlans);
          setPlanYearly(enhancedYearlyPlans);

          setPlanTypeShow("Month");
          setPlanToShow(monthlyPlans);
        }
      } catch (err) {
        addToast({
          error: true,
          msg: err.message || "Failed to load plan data",
        });
      }
    }

    if (tab !== "add" && tab !== "edit") fetchPlanWithFeatures();
  }, [tab, isdowngradeProcessed, addToast]); // Added addToast dependency

  useEffect(() => {
    // Global error handler for the pricing page
    const handleError = (error) => {
      console.error("Pricing page error:", error);
      addToast({
        error: true,
        msg: "An unexpected error occurred. Please refresh the page and try again.",
      });
    };

    const handleUnhandledRejection = (event) => {
      console.error("Unhandled promise rejection:", event.reason);
      addToast({
        error: true,
        msg: "A network error occurred. Please check your connection and try again.",
      });
    };

    window.addEventListener("error", handleError);
    window.addEventListener("unhandledrejection", handleUnhandledRejection);

    return () => {
      window.removeEventListener("error", handleError);
      window.removeEventListener(
        "unhandledrejection",
        handleUnhandledRejection
      );
    };
  }, [addToast]); // Added addToast dependency

  const changePlan = (type) => {
    setPlanType(type);
    if (type === "monthly") {
      setPlanTypeShow("Month");
      setPlanToShow(planMonthly);
    }
    if (type === "yearly") {
      setPlanTypeShow("Year");
      setPlanToShow(planYearly);
    }
  };

  const chkLogin = (product, action) => {
    try {
      if (!product) {
        addToast({
          error: true,
          msg: "Invalid product selected. Please try again.",
        });
        return;
      }
      if (profiles === undefined) {
        setSubsProductId(product?.product_id);
        setModal("pricingformCreate");
      } else {
        setUpdateAction(action);
        setActionProduct(product);
        setModal("confirmAction");
      }
    } catch (error) {
      console.error("Error in chkLogin:", error);
      addToast({
        error: true,
        msg: "An error occurred. Please try again.",
      });
    }
  };

  const doSubscription = async (product, action) => {
    setIsSubscriptionLoading(true);
    setLoadingPlanId(product.id); // Set the specific plan ID that's loading
    setModal("");

    const payload = {
      product_id: product.id,
      amount: product.price,
      description: product.description,
      account: "paypal",
      plan_id: product.pp,
      billing_cycle: product.billing_cycle,
      action: action,
    };

    try {
      const res = await safeApiCall(() =>
        billingService.addSubscribePlan(payload)
      );

      setUpdateAction("");
      setActionProduct(null);
      setUserInfo();
      if (res?.error) {
        let errorMsg = res.message || "Subscription failed";
        if (res?.code === 408) {
          setIsSubscribe(true);
          errorMsg =
            "Looks like you've already used your trial. Don't worry—you can still unlock full access by choosing a plan.";
        }
        addToast({
          error: true,
          msg: errorMsg,
        });
        return;
      }

      // Refresh pricing data after successful subscription
      try {
        const planRes = await safeApiCall(() =>
          planService.getPlanWithFeatures()
        );

        if (planRes?.data && planRes?.success) {
          const resSubscription =
            await planService.getAllForActiveSubscriptionData();
          console.log(
            "🚀 ~ doSubscription ~ resSubscription:",
            resSubscription
          );
          const { monthlyPlans, yearlyPlans } = planRes.data?.reduce(
            (acc, plan) => {
              console.log("🚀 ~ doSubscription ~ plan:", plan);
              if (
                plan?.billing_options &&
                Array.isArray(plan.billing_options)
              ) {
                plan.billing_options.forEach((option) => {
                  const subscriptionData = resSubscription?.data?.find(
                    (item) =>
                      item.product_name === plan.name &&
                      item.product_id === option.id
                    // item?.product_name === plan?.name &&
                    // item?.billing_cycle === option?.billing_cycle &&
                    // parseFloat(item?.price || 0) === (option?.price || 0)
                  );
                  // const enhancedPlan = {
                  //   ...plan,
                  //   ...option,
                  //   ...(subscriptionData && {
                  //     planaction: subscriptionData.planaction,
                  //     user_flag: subscriptionData.user_flag,
                  //     startdate: subscriptionData.startdate,
                  //     isSubscribed: true,
                  //   }),
                  // };
                  const enhancedPlan = {
                    ...plan,
                    ...option,
                    ...(subscriptionData && {
                      planaction: subscriptionData.planaction,
                      user_flag: subscriptionData.user_flag,
                      startdate: subscriptionData.startdate,
                      user_trial: subscriptionData.user_trial,
                      trial_days_left: subscriptionData.trial_days_left,
                      user_had_trial: subscriptionData.user_had_trial,
                      // is_trial: subscriptionData.is_trial,
                      isSubscribed: true,
                      // trial_days: subscriptionData.trial_days,
                    }),
                  };
                  if (option?.billing_cycle === "monthly") {
                    acc.monthlyPlans.push(enhancedPlan);
                  } else {
                    acc.yearlyPlans.push(enhancedPlan);
                  }
                });
              }
              return acc;
            },
            { monthlyPlans: [], yearlyPlans: [] }
          );

          const sortedPlans = (plans) => {
            return plans.sort((a, b) => {
              if (a?.display_order === 0) return -1;
              if (b?.display_order === 0) return 1;
              if (a?.display_order === 3) return 1;
              if (b?.display_order === 3) return -1;
              return (a?.display_order || 0) - (b?.display_order || 0);
            });
          };

          const enhancedMonthlyPlans = sortedPlans(monthlyPlans);
          const enhancedYearlyPlans = sortedPlans(yearlyPlans);

          setPlanMonthly(enhancedMonthlyPlans);
          setPlanYearly(enhancedYearlyPlans);

          // Update current plan display based on selected type
          if (planType === "monthly") {
            setPlanToShow(enhancedMonthlyPlans);
          } else {
            setPlanToShow(enhancedYearlyPlans);
          }
        }
      } catch (refreshError) {
        console.error("Error refreshing pricing data:", refreshError);
      }

      if (action === "Downgrade") {
        addToast({
          error: false,
          msg: res.message || "Plan downgraded successfully",
        });
        setIsdowngradeProcessed(!isdowngradeProcessed);
      } else {
        if (res?.data?.url) {
          try {
            window.location.replace(res.data.url);
          } catch (redirectError) {
            console.error("Redirect error:", redirectError);
            addToast({
              error: true,
              msg: "Redirect failed. Please try again.",
            });
          }
        }
      }
    } catch (error) {
      console.error("Subscription error:", error);
      addToast({
        error: true,
        msg:
          error?.message || error || "Subscription failed. Please try again.",
      });
    } finally {
      setIsSubscriptionLoading(false);
      setLoadingPlanId(null); // Clear the loading plan ID
    }
  };

  return (
    <>
      {profiles !== undefined ? (
        <div className="main">
          <div
            className={
              "main__inner" + (profiles === undefined ? " nopadding" : "")
            }
          >
            {planToShow?.length > 0 && (
              <PricingMain
                setToastList={setToastList}
                toastList={toastList}
                planToShow={planToShow}
                chkLogin={chkLogin}
                changePlan={changePlan}
                planType={planType}
                planTypeShow={planTypeShow}
                profiles={profiles}
                loadingPlanId={loadingPlanId}
              />
            )}
          </div>
        </div>
      ) : (
        <div className="searchouterpage">
          <HeaderAcc />
          <div
            className="account__inner"
            style={{ margin: "0 auto", width: "fit-content" }}
          >
            <div>
              <div className="account__inner-col-image">
                <div>
                  {planToShow?.length > 0 && (
                    <PricingMain
                      planToShow={planToShow}
                      chkLogin={chkLogin}
                      changePlan={changePlan}
                      planType={planType}
                      planTypeShow={planTypeShow}
                      setToastList={setToastList}
                      toastList={toastList}
                      profiles={profiles}
                      loadingPlanId={loadingPlanId}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {modal === "pricingPlatformCreate" && (
        <ModalPricingPlatformCreate
          setReferId={setReferId}
          setRoleId={setRoleId}
          close={() => setModal(null)}
          setModal={setModal}
          subsProductId={subsProductId}
        />
      )}
      {(modal === "terms" ||
        modal === "termsCreate" ||
        modal === "pricingTermsCreate") && (
        <ModalAccActivation
          close={() => {
            setModal("pricingPlatformCreate");
          }}
        />
      )}
      {subModal === "terms" && (
        <ModalAccActivation
          close={() => {
            if (subModal === "terms") {
              setSubModal(null);
            }
          }}
        />
      )}
      {modal === "pricingformCreate" && (
        <ModalPricingformCreate
          setReferId={setReferId}
          referId={referId}
          setRoleId={setRoleId}
          close={() => setModal(null)}
          setModal={setModal}
          setSubModal={setSubModal}
          subsProductId={subsProductId}
          setToastList={setToastList}
          toastList={toastList}
        />
      )}
      {modal === "pricingsignin" && (
        <ModalPricingSignIn
          close={() => setModal(null)}
          setModal={setModal}
          setSubModal={setSubModal}
          subsProductId={subsProductId}
          referPageUrl={referPageUrl}
          setToastList={setToastList}
          toastList={toastList}
        />
      )}
      {modal === "confirmAction" && (
        <ModalConfirmSubscriptionAction
          close={() => setModal(null)}
          setModal={setModal}
          action={updateAction}
          onConfirm={() => doSubscription(actionProduct, updateAction)}
        />
      )}
      {modal === "subscribeNow" && (
        <ModalSubscribe
          close={() => {
            setModal(null);
            setIsSubscribe(false); // reset after closing
          }}
          setModal={setModal}
        />
      )}
      {toastList && <Toast list={toastList} setList={setToastList} />}
    </>
  );
}
